import React from "react";
import AvatarDefault from "@assets/images/ava.svg";
import { Col, Image, Row } from "antd";
import { useTranslation } from "react-i18next";
import "./index.scss";
import { getPotentialWinner } from "dataLayer/product";
import { useQuery } from "react-query";

const PotentialWinner = ({ product }) => {
  const { t } = useTranslation();
  
  const { data: potentialWinnerData } = useQuery(
    getPotentialWinner(product?.cp_id)
  );

  return (
    <>
      {potentialWinnerData ? (
        <Row justify="center" gutter={[35, 35]}>
          <Col xs={24} className={"potentialwinner-wrapper"}>
            <div className="potential-winner">
              <div className="potential-winner__user">
                <h1 className="potential-winner__user--title">
                  {t("potential_winner.title")}
                </h1>
                <div className="potential-winner__user--info">
                  <Image
                    src={potentialWinnerData?.image || AvatarDefault}
                    preview={false}
                    alt="User's avatar"
                    width={40}
                    height={40}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = AvatarDefault;
                    }}
                  />
                  <div className="potential-winner__user--info-detail">
                    <p className="potential-winner__user--info-detail-price">
                      {potentialWinnerData?.price}
                    </p>
                    <p className="potential-winner__user--info-detail-phone">
                      {potentialWinnerData?.name || potentialWinnerData?.isdn}
                    </p>
                  </div>
                </div>
              </div>
              <p className="potential-winner__text">
                {t("potential_winner.text").replace(
                  "_PRODUCTNAME_",
                  `${product?.product_name}`
                )}
              </p>
            </div>
          </Col>
        </Row>
      ) : null}
    </>
  );
};

export default PotentialWinner;
